// Waiting for a bank to tell us the customer authorised.
//
// The customer leaves for the bank's own site and comes back through
// /psd2/redirect/<bank>, which is a different request entirely. The server
// announces the outcome over a socket, and the page is sitting here waiting for
// it - so this is the one part of the journey with no HTTP response to wait on.
(function (global) {
  "use strict";

  // How long the customer gets before we give up on them.
  const AUTHORISATION_TIMEOUT_SECONDS = 120;

  class WebSocketClient {
    constructor() {
      this.socket = global.io();
      this.intervalId = null;
      this.counter = 0;
    }

    getCounter() {
      return this.counter;
    }

    // What is left on the clock, as "1:59". Both phases display this, and they
    // used to format it separately and disagree by a couple of seconds.
    remaining() {
      const seconds = Math.max(this.counter, 0);
      const minutes = Math.floor(seconds / 60);
      const rest = seconds % 60;
      return `${minutes}:${rest < 10 ? "0" : ""}${rest}`;
    }

    // Resolves with the bank's final status, or rejects when the clock runs
    // out. The listener is always removed afterwards: it used to be added per
    // call and never taken off, so a single connection accumulated one live
    // handler per bank per phase, all of them still firing.
    startListening(bankName, eventName) {
      this.counter = AUTHORISATION_TIMEOUT_SECONDS;

      return new Promise((resolve, reject) => {
        const cleanUp = () => {
          clearTimeout(timeoutId);
          clearInterval(this.intervalId);
          this.socket.off(eventName, onStatus);
        };

        const onStatus = (data) => {
          if (data.bank !== bankName) return;
          if (data.status !== "valid" && data.status !== "rejected") return;
          cleanUp();
          resolve(data.status);
        };

        const timeoutId = setTimeout(() => {
          cleanUp();
          reject(new Error(`Timeout after ${AUTHORISATION_TIMEOUT_SECONDS}s`));
        }, AUTHORISATION_TIMEOUT_SECONDS * 1000);

        this.intervalId = setInterval(() => {
          this.counter--;
          if (this.counter < 0) clearInterval(this.intervalId);
        }, 1000);

        this.socket.on(eventName, onStatus);
      });
    }
  }

  const api = { WebSocketClient, AUTHORISATION_TIMEOUT_SECONDS };
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
  Object.assign(global, api);
})(typeof window !== "undefined" ? window : globalThis);
